import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ExternalViewContextService } from '@context/frontend/user';

/**
 * Light guard for the viewer content stack (`/content/:externalId/...`).
 *
 * The heavy lifting - link lookup, authentication, and session setup - happens once
 * on the `view/:externalId` proxy route via {@link ExternalViewAuthGuard}. This guard
 * only confirms that the proxy populated the share context. If it didn't (e.g. a hard
 * reload or a deep link straight into the content stack), it bounces back through the
 * proxy so the session can be re-established, instead of re-running auth here.
 */
export const externalContentGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
) => {
	const context = inject(ExternalViewContextService);
	const router = inject(Router);

	if (context.data()) return true;

	const externalId = route.paramMap.get('externalId');
	return router.createUrlTree(externalId ? ['/view', externalId] : ['/']);
};
